/* TOPページ：メインビジュアルにおける処理を記述 */

// スクロールに伴うビジュアル変化管理
function mainVisualObserver() {

  // 共通変数設定
  const parentTarget = document.querySelector('#topMainVisual'),
        blockArray = parentTarget.querySelectorAll('.c-top-mainvisual__block'),
        titleArray = parentTarget.querySelectorAll('.c-top-mainvisual__title'),
        tagArray = parentTarget.querySelectorAll('.c-top-mainvisual__tag'),
        videoArray = parentTarget.querySelectorAll('.c-top-mainvisual__aside');
  let observer = null;

  /* 
    InterSectionObserver関連処理 =====================
  */
  function doWhenIntersect(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        setVisibleClass(entry.target.dataset.blockId)
      } else {
        entry.target.classList.remove('is-visible');
      }
    });
  }
  // 交差判定に伴うクラス名の処理
  function setVisibleClass(id) {
    titleArray.forEach(title => {
      title.classList.remove('is-visible');
      if (title.dataset.blockId === id) {
        title.classList.add('is-visible');
      }
    });
    tagArray.forEach(tag => {
      tag.classList.remove('is-visible');
      if (tag.dataset.blockId === id) {
        tag.classList.add('is-visible');
      }
    });
    videoArray.forEach(video => {
      video.classList.remove('is-visible');
      if (video.dataset.blockId === id) {
        video.classList.add('is-visible');
      }
    });
  }

  // SP端末での実行分岐
  function getRootMarginValue() {
    if (window.innerWidth <= 740) {
      return "-55% 0px -45% 0px";
    } else {
      return "-80% 0px -120px 0px";
    }
  }

  // observerの初期化と実行
  function initObserver() {
    if (observer) {
      observer.disconnect();
    }
    const options = {
      root: parentTarget,
      rootMargin: getRootMarginValue(),
      threshold: 0
    };
    observer = new IntersectionObserver(doWhenIntersect, options);
    blockArray.forEach(block => {
      observer.observe(block);
    });
  }
  initObserver();
  window.addEventListener('resize', initObserver);

  /* 
    スクロール位置判定によるメインビジュアル内スクロールロック =====================
  */
  const AnnouncementBar = document.querySelector('announcement-bar');
  let headerFixOffset = 0;
  if (AnnouncementBar) {
    headerFixOffset = AnnouncementBar.clientHeight;
  }

  function headerScrollCheck(scrollY) {
    if (scrollY > headerFixOffset) {
      parentTarget.classList.add("scroll-rocked");
    } else {
      parentTarget.classList.remove("scroll-rocked");
    }
  }
  window.addEventListener('scroll', function(){
    headerScrollCheck(window.scrollY);
  });
}

// 現在時刻の表示とアップデート
function updateClock() {
  const now = new Date(),
        clockTarget = document.querySelectorAll(".c-top-mainvisual__time--text"),
        jst = new Date(now.getTime() + (9 * 60 * 60 * 1000));
  let h = String(jst.getUTCHours()).padStart(2, "0");
  let m = String(jst.getUTCMinutes()).padStart(2, "0");
  let s = String(jst.getUTCSeconds()).padStart(2, "0");

  clockTarget.forEach(target => {
    target.textContent = `${h}:${m}:${s}`;
  })
}

// WeatherAPIを利用した天気の表示
function setWeather() {
  const mainVisual = document.querySelector("#topMainVisual"),
        weatherTempArea = document.querySelectorAll(".c-top-mainvisual__time--temp"),
        API_KEY = mainVisual.dataset.weather,
        defaultLocation = { lat: 35.6895, lon: 139.6917 }; //Tokyo

  function fetchWeather(lat, lon, fallback = false) {
    const url = `https://api.weatherapi.com/v1/current.json?key=${API_KEY}&q=${lat},${lon}&lang=ja`;

    fetch(url)
      .then(response => response.json())
      .then(data => {
        const location = data.location.name;
        const temp = Math.round(data.current.temp_c);
        const condition = data.current.condition.text;
        const conditionClass = getConditionClass(condition);

        mainVisual.classList.add(conditionClass);

        weatherTempArea.forEach(target => {
          target.textContent = `${temp}°`;
        })
      })
      .catch(error => {
        console.error('天気情報の取得に失敗しました:', error);
      });
  }

  // 取得した天気情報に基づくClass名の付与
  function getConditionClass(condition) {
    if (condition.includes('晴')) return 'weather-sunny';
    if (condition.includes('曇')) return 'weather-cloudy';
    if (condition.includes('雨')) return 'weather-rainy';
    if (condition.includes('雪')) return 'weather-snowy';
    return 'weather-default';
  }
  fetchWeather(defaultLocation.lat, defaultLocation.lon);
}

window.addEventListener('DOMContentLoaded', function(){
  updateClock();
  setWeather();
  setInterval(updateClock, 1000);
});

window.addEventListener('load', function(){
  mainVisualObserver();
});